/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：105__part-1
 */

"use strict"

var u
var c
var s
var a
var o
var i
var r
import * as /* [auto-meaningful-name] */Hammerjs from /* 562 */"hammerjs"
!function (e) {
  e.Actor = "actor"
  e.Scene = "scene"
  e.Background = "background"
  e.ActorDialog = "actor_dialog"
}(r || (r = {}));
(function (e) {
  e.ActorWrapper = "actor_wrapper"
})(i || (i = {}));
(function (e) {
  e[e.ALL = 0] = "ALL"
  e[e.LEFT_RIGHT = 1] = "LEFT_RIGHT"
  e[e.NONE = 2] = "NONE"
})(o || (o = {}));
(function (e) {
  e[e.UP = Hammerjs.DIRECTION_UP] = "UP"
  e[e.DOWN = Hammerjs.DIRECTION_DOWN] = "DOWN"
  e[e.LEFT = Hammerjs.DIRECTION_LEFT] = "LEFT"
  e[e.RIGHT = Hammerjs.DIRECTION_RIGHT] = "RIGHT"
})(a || (a = {}));
(function (e) {
  e.TO = "to"
  e.FROM = "from"
  e.FROM_TO = "from_to"
})(s || (s = {}));
(function (e) {
  e[e.RIGHT = 8] = "RIGHT"
  e[e.LEFT = 4] = "LEFT"
  e[e.TOP = 2] = "TOP"
  e[e.BOTTOM = 1] = "BOTTOM"
})(c || (c = {}));
(function (e) {
  e.CONTAIN = "contain"
  e.COVER = "cover"
  e.STRETCH = "stretch"
})(u || (u = {}))
export { r }
export { i }
export { o }
export { s }
export { c }
export { u }
